<template>
  <div class="mk-resource__content">
    <div
      v-for = "product in products"
      :key  = "`${keyPrefix}-${product.id}`"
      class = "mk-resource__item"
      :style= "productStyle"
    >
      <div class="mk-resource__item-content">
        <a @click="productClick(product.slug)">
          <div class="mk-image-box">
            <img :src="product.img_url">
          </div>

          <div class="ps-2 pt-3 pb-3">
            <div class="pb-3 mk-resource__item-title">{{product.name}}</div>
            <div class="mk-resource__item-subtitle">NT$ {{ product.selling_price }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue'

  const props = defineProps({
    products: Array,
    productStyle: String,
    keyPrefix: String,
  });

  const emit = defineEmits(["onProductClick"]);

  const productClick = (slug) => {
    emit('onProductClick', slug);
  }
</script>